import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_0eeb16d9 from 'nuxt_plugin_bootstrapvue_0eeb16d9' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_nuxtbreakpoints_cdf450d4 from 'nuxt_plugin_nuxtbreakpoints_cdf450d4' // Source: ./nuxt-breakpoints.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_58058e52 from 'nuxt_plugin_cookieuniversalnuxt_58058e52' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_libplugin595d7a99_596cc731 from 'nuxt_plugin_libplugin595d7a99_596cc731' // Source: ./lib.plugin.595d7a99.js (mode: 'all')
import nuxt_plugin_nuxtcookiecontrol_2034f13c from 'nuxt_plugin_nuxtcookiecontrol_2034f13c' // Source: ./nuxt-cookie-control.js (mode: 'all')
import nuxt_plugin_shopify_07f152cc from 'nuxt_plugin_shopify_07f152cc' // Source: ./shopify.js (mode: 'all')
import nuxt_plugin_pluginseo_28f94865 from 'nuxt_plugin_pluginseo_28f94865' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_89121c48 from 'nuxt_plugin_pluginrouting_89121c48' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_9c82b1da from 'nuxt_plugin_pluginmain_9c82b1da' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_globalcomponents_a1486440 from 'nuxt_plugin_globalcomponents_a1486440' // Source: ./global-components.js (mode: 'all')
import nuxt_plugin_axios_538282aa from 'nuxt_plugin_axios_538282aa' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_globaldirectives_a010367e from 'nuxt_plugin_globaldirectives_a010367e' // Source: ../plugins/global-directives.client (mode: 'client')
import nuxt_plugin_vueclickoutside_0d341e76 from 'nuxt_plugin_vueclickoutside_0d341e76' // Source: ../plugins/vue-click-outside.client (mode: 'client')
import nuxt_plugin_vueshopifyimages_058432fc from 'nuxt_plugin_vueshopifyimages_058432fc' // Source: ../plugins/vue-shopify-images (mode: 'all')
import nuxt_plugin_vueswiper_05ba9144 from 'nuxt_plugin_vueswiper_05ba9144' // Source: ../plugins/vue-swiper.client (mode: 'client')
import nuxt_plugin_vuequerystring_588e95da from 'nuxt_plugin_vuequerystring_588e95da' // Source: ../plugins/vue-query-string (mode: 'all')
import nuxt_plugin_vueobservevisibility_9bd06b0e from 'nuxt_plugin_vueobservevisibility_9bd06b0e' // Source: ../plugins/vue-observe-visibility.client (mode: 'client')
import nuxt_plugin_vuelazysizes_adc2d810 from 'nuxt_plugin_vuelazysizes_adc2d810' // Source: ../plugins/vue-lazysizes.client (mode: 'client')
import nuxt_plugin_vuelodash_233b7c9c from 'nuxt_plugin_vuelodash_233b7c9c' // Source: ../plugins/vue-lodash (mode: 'all')
import nuxt_plugin_vueshopcolors_39d0b82a from 'nuxt_plugin_vueshopcolors_39d0b82a' // Source: ../plugins/vue-shop-colors (mode: 'all')
import nuxt_plugin_vueproductfilter_603d1f33 from 'nuxt_plugin_vueproductfilter_603d1f33' // Source: ../plugins/vue-product-filter (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Fjqj5ddw.css"}],"meta":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_0eeb16d9 === 'function') {
    await nuxt_plugin_bootstrapvue_0eeb16d9(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtbreakpoints_cdf450d4 === 'function') {
    await nuxt_plugin_nuxtbreakpoints_cdf450d4(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_58058e52 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_58058e52(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin595d7a99_596cc731 === 'function') {
    await nuxt_plugin_libplugin595d7a99_596cc731(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcookiecontrol_2034f13c === 'function') {
    await nuxt_plugin_nuxtcookiecontrol_2034f13c(app.context, inject)
  }

  if (typeof nuxt_plugin_shopify_07f152cc === 'function') {
    await nuxt_plugin_shopify_07f152cc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_28f94865 === 'function') {
    await nuxt_plugin_pluginseo_28f94865(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_89121c48 === 'function') {
    await nuxt_plugin_pluginrouting_89121c48(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_9c82b1da === 'function') {
    await nuxt_plugin_pluginmain_9c82b1da(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_a1486440 === 'function') {
    await nuxt_plugin_globalcomponents_a1486440(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_538282aa === 'function') {
    await nuxt_plugin_axios_538282aa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globaldirectives_a010367e === 'function') {
    await nuxt_plugin_globaldirectives_a010367e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclickoutside_0d341e76 === 'function') {
    await nuxt_plugin_vueclickoutside_0d341e76(app.context, inject)
  }

  if (typeof nuxt_plugin_vueshopifyimages_058432fc === 'function') {
    await nuxt_plugin_vueshopifyimages_058432fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueswiper_05ba9144 === 'function') {
    await nuxt_plugin_vueswiper_05ba9144(app.context, inject)
  }

  if (typeof nuxt_plugin_vuequerystring_588e95da === 'function') {
    await nuxt_plugin_vuequerystring_588e95da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_9bd06b0e === 'function') {
    await nuxt_plugin_vueobservevisibility_9bd06b0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazysizes_adc2d810 === 'function') {
    await nuxt_plugin_vuelazysizes_adc2d810(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelodash_233b7c9c === 'function') {
    await nuxt_plugin_vuelodash_233b7c9c(app.context, inject)
  }

  if (typeof nuxt_plugin_vueshopcolors_39d0b82a === 'function') {
    await nuxt_plugin_vueshopcolors_39d0b82a(app.context, inject)
  }

  if (typeof nuxt_plugin_vueproductfilter_603d1f33 === 'function') {
    await nuxt_plugin_vueproductfilter_603d1f33(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
